const initialState = {}

const OPEN_MODAL_TYPE = 'OPEN_MODAL'
const CLOSE_MODAL_TYPE = 'CLOSE_MODAL'

export const closeModalAction = () => ({ type: CLOSE_MODAL_TYPE })

export const openModalAction = (modalParams = {}) => ({
    type: OPEN_MODAL_TYPE,
    payload: modalParams
})

export default function showModalReducer(state = initialState, action = {}) {
    const { type, payload } = action
    switch (type) {
        case OPEN_MODAL_TYPE:
            return payload
        case CLOSE_MODAL_TYPE:
            return initialState
        default: return state
    }
}